// Common home health call parameters; values outside these are flagged red
const num = (v) => { const m = String(v ?? '').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };

const tempOut = (v) => {
  const t = num(v);
  if (t == null) return null;
  return t < 50 ? (t < 36 || t > 38 ? 'Temp outside 36-38 °C' : null) : (t < 96.8 || t > 100.4 ? 'Temp outside 96.8-100.4 °F' : null);
};

const range = (lo, hi, label) => (v) => {
  const n = num(v);
  return n != null && (n < lo || n > hi) ? `${label} outside ${lo}-${hi}` : null;
};

const bpOut = (v) => {
  const [s, d] = String(v ?? '').split('/').map(num);
  const msgs = [];
  if (s != null && (s < 90 || s > 160)) msgs.push('Systolic outside 90-160');
  if (d != null && (d < 50 || d > 90)) msgs.push('Diastolic outside 50-90');
  return msgs.length ? msgs.join('; ') : null;
};

export const VITAL_RULES = {
  temperature: tempOut,
  pulse: range(60, 100, 'Pulse'),
  respiration: range(12, 20, 'Resp'),
  bloodPressure: bpOut,
  oxygenSaturation: (v) => { const n = num(v); return n != null && n < 92 ? 'O2 below 92%' : null; },
  bloodSugar: range(70, 250, 'Blood sugar'),
  pain: (v) => { const n = num(v); return n != null && n >= 7 ? 'Pain 7 or higher' : null; },
};

export const LIMITS_TEXT = 'Temp 96.8-100.4 °F · Pulse 60-100 · Resp 12-20 · BP 90-160 / 50-90 · O2 ≥ 92% · Sugar 70-250 · Pain < 7';
